// bernie
import { Store } from 'bernie-plugin-mobx';
import { SerializedData } from 'bernie-core';
import { Logger, NOOP_LOGGER } from 'bernie-logger';

// mobx
import { makeObservable, action, observable } from 'mobx';

export class LinkStore extends Store {
  public language: string;
  public pid: string;
  public sid: string;
  public channel: string;
  public camRef: string;
  public adRef: string;
  public creativeRef: string;
  public pubRef: string;

  public constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);

    makeObservable(this, {
      language: observable,
      pid: observable,
      sid: observable,
      channel: observable,
      camRef: observable,
      adRef: observable,
      creativeRef: observable,
      pubRef: observable,
      setLanguage: action,
      setPid: action,
      setSid: action,
      setChannel: action,
      setCamRef: action,
      setAdRef: action,
      setCreativeref: action,
      setPubRef: action,
    });
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public setLanguage(language) {
    this.language = language;
  }

  public setPid(pid) {
    this.pid = pid;
  }

  public setSid(sid) {
    this.sid = sid;
  }

  public setChannel(channel) {
    this.channel = channel;
  }

  public setCamRef(camRef) {
    this.camRef = camRef;
  }

  public setAdRef(adRef) {
    this.adRef = adRef;
  }

  public setCreativeref(cRef) {
    this.creativeRef = cRef;
  }

  public setPubRef(pubRef) {
    this.pubRef = pubRef;
  }
}
